jQuery(document).ready(function($){

  function preselectQuickBuySize(modal) {

    const cartItem = document.querySelector('.cart-drawer__items .line-item-size-variant .size-option');

    const addButton = modal.querySelector('.add_to_cart');

    setTimeout(function(){
      modal.querySelector('product-rerender').setAttribute('data-select',true);
    },800)

    setTimeout(function(){
      modal.querySelector('product-rerender').setAttribute('data-select',true);
    },1400) 

    // No product in cart
    if (!cartItem) {
      modal.querySelectorAll('.size-swatch-fieldset input[type="radio"]').forEach(input => {
        input.checked = false;
      });

      if (addButton) {
        addButton.disabled = true;
        addButton.classList.add('is-disabled');
        addButton.innerText = "Select a size";
      }

      return;
    }

    // Shopify option1 = Size
    const size = cartItem.innerText;

    if (!size) return;

    // Find matching radio
    const radio = [...modal.querySelectorAll('.size-swatch-fieldset input[type="radio"]')]
      .find(input => {
        const label = modal.querySelector(`label[for="${input.id}"]`);
        return label?.textContent.trim() === size;
      });

    if (radio) {
      radio.checked = true;           

      // Trigger your theme's variant picker
      radio.dispatchEvent(new Event('change', {
        bubbles: true
      }));

      if (addButton) {
        addButton.disabled = false;
        addButton.classList.remove('is-disabled');
        addButton.innerText = "+Add";
      }
    }
  }
  
  const observer = new MutationObserver(() => {
    const modal = document.querySelector('quick-buy-modal[open]');

    if (modal && !modal.dataset.sizePrefilled) {
      modal.dataset.sizePrefilled = 'true';
      preselectQuickBuySize(modal);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  $('.footer__block--links p.h4, .footer__block--text p.h4').click(function(){
    $(this).parents('.footer__block').toggleClass('open');
  });
  
  $('.cat-tab-nav-item').click(function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    let tab = $(this).data('id');
    $(this).closest('.cat-tab-wrapper').find('.cat-tab-item').removeClass('active');
    $('#' + tab).addClass('active');
  }); 

  // Product Fake Description Function
  if ($( ".fake-description" ).length > 0){
    let detail = $( "#custom_detail" ).html();
    $("div.description_detail").append(detail);
  }

  $(document).on('click', '.drawer-filter-item-wrapper .checkbox-control', function(){
    $('#facets-drawer .close-filter-drawer').click();
  });

  $('.custom-card-variant-image').click(function(){
    let url = $(this).data('url');
    let img = $(this).data('image');
    let value = $(this).data('value');
    let parent = $(this).closest('.product-custom-card');
    parent.find('.custom-card-variant-image').removeClass('active');
    $(this).addClass('active');
    parent.find('.custom-card-main-mdeia img').attr('src', img);
    parent.find('.view-card-item a').attr('href', url);
    parent.find('.more-viariants a').attr('href', url);
    parent.find('.card-selected-color').text(value);
    
    
  });
    
  

  if ($('.lookbook-products-slider').length){
    $('.lookbook-products-slider').slick({
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 3,
      variableWidth: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 9000,
      arrows: false,
      responsive: [
        {
          breakpoint: 699,
          settings: {
            slidesToShow: 2,
            arrows: true,
          }
        }
      ]
    });
  }
});